
import { useQuery } from "@tanstack/react-query";
import { getTransactionsList } from "../../API/ProtectedAuth";
import { handleApiError } from "../../Utils/errorHandler";

/**
 * Hook مسؤول عن جلب معاملات المحفظة مع إدارة الكاش
 * - يأخذ queryParams كـ object
 * - يعيد: transactions, total, next, previous, isLoading, error, refetch
 */
export const useTransactionsList = (queryParams = {}) => {
  const queryKey = ["transactions", queryParams]; 

  const {
    data,
    error,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey,
    queryFn: async () => {
      try {
        return await getTransactionsList(queryParams);
      } catch (err) {
        handleApiError(err);
        throw err;
      }
    },
    keepPreviousData: true, 
    staleTime: 1000 * 60 * 30, 
    cacheTime: 1000 * 60 * 60 * 12, 
    refetchOnWindowFocus: false, 
  });

  return {
    transactions: data?.transactions ?? [],
    total: data?.total ?? 0,
    next: data?.next ?? null,
    previous: data?.previous ?? null,
    isLoading,
    isFetching,
    error,
    refetch,
  };
};














































